import { connect } from 'react-redux';

import { CONTENTFUL_HEYCAR, WEB_APP_URL } from 'app/config';
import { getPage } from 'app/marketplace/contentful/actions';
import { getPropsFromPage } from 'app/marketplace/contentful/utils';

import { Contentful } from './InsuranceHub';

Contentful.loadAction = (_, props) => {
  return (dispatch) => {
    const { pathname } = props.location;

    return Promise.all([
      dispatch(getPage(pathname, CONTENTFUL_HEYCAR, WEB_APP_URL)),
    ]);
  };
};

function mapStateToProps(state, ownProps) {
  const path = ownProps.location.pathname;
  const { contentfulLoading, entry } = getPropsFromPage(state, path);
  return {
    contentfulLoading: entry ? contentfulLoading : true,
    entry,
    locale: 'de',
  };
}

export const ConnectedInsuranceHub = connect(mapStateToProps, {
  getPage,
})(Contentful);
